<template>
  <Cell
    v-if="column.render"
    :row="row"
    :column="column"
    :index="cindex"
    :render="column.render">
  </Cell>
</template>

<script>
import Cell from './cell-expand'
export default {
  name: 'render-cell',
  components: { Cell },
  props: {
    row: {
      required: true
    },
    column: {
      required: true
    },
    cindex: {
      required: true
    }
  }
}
</script>

<style scoped>

</style>
